<template>
    <div>
        <div class="PatchCommandParameters-title">
            <div>
                <Breadcrumb>
                    <BreadcrumbItem>{{$t('PatchEasy.PatchCmd.title')}}</BreadcrumbItem>
                </Breadcrumb>
            </div>
        </div>
        <template>
            <Tabs size="small" :animated="false">
                <TabPane :label="$t('PatchEasy.PatchCmd.command')">
                    <div class="PatchCommandParameters-top">
                        <command-search></command-search>
                    </div>
                    <table-command></table-command>
                </TabPane>
                <TabPane :label="$t('PatchEasy.PatchCmd.commandHistory')">
                    <div class="PatchCommandParameters-top">
                        <command-history-search></command-history-search>
                    </div>
                    <table-command-history></table-command-history>
                </TabPane>
            </Tabs>
        </template>
    </div>
</template>

<script>
    import CommandSearch from '../patch_command_parameters/CommandSearch'
    import CommandHistorySearch from '../patch_command_parameters/CommandHistorySearch'
    import TableCommandHistory from '../patch_command_parameters/TableCommandHistory'
    import TableCommand from '../patch_command_parameters/TableCommand'

    export default {
        name: 'PatchCommandParameters',
        components: {
            CommandSearch,
            CommandHistorySearch,
            TableCommand,
            TableCommandHistory
        },
        data(){
            return {
            }
        }
    }
</script>

<style scoped>
    .PatchCommandParameters-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
        font-weight: 600;
        overflow: hidden;
    }
    .PatchCommandParameters-title>div:nth-child(1)
    {
        float:left;
    }
    .PatchCommandParameters-title>div:nth-child(2)
    {
        float:right;
        margin-top: -6px;
    }
    .PatchCommandParameters-top
    {
        width: 100%;
        height: 32px;
        margin-bottom: 14px;
    }
    .ivu-breadcrumb {
        font-size: 13px;
        font-weight: 600;
        color: #515a6e;
    }
</style>



// WEBPACK FOOTER //
// src/components/patch_management/patch_command_parameters/PatchCommandParameters.vue